(function () {
  function parseJson(container, selector, fallback) {
    const script = container.querySelector(selector);
    if (!script) return fallback;

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return fallback;
    }
  }

  function normalize(value) {
    return String(value || '').trim().toLowerCase();
  }

  function findOptionIndex(optionNames, terms) {
    return optionNames.findIndex((name) => {
      const normalizedName = normalize(name);
      return terms.some((term) => normalizedName.includes(term));
    });
  }

  function formatMoney(cents) {
    const amount = Number(cents || 0) / 100;
    return `$${amount.toFixed(2)}`;
  }

  function formatMoneyAmount(amount) {
    return `$${Math.max(0, Number(amount || 0)).toFixed(2)}`;
  }

  function formatMil(value) {
    return `${Number.isInteger(value) ? value : value.toFixed(1)} mil`;
  }

  function calculateThickness(material, lamination) {
    const materialName = normalize(material);
    const laminationName = normalize(lamination);
    const materialThickness = materialName.includes('reflective') ? 6 : 3.2;
    const hasLaminate =
      !laminationName.includes('no lamination') &&
      (laminationName.includes('yes') ||
        laminationName.includes('laminate') ||
        laminationName.includes('lamination'));
    const laminateThickness = hasLaminate ? 2 : 0;
    const finishedThickness = materialThickness + laminateThickness;

    return {
      material: formatMil(materialThickness),
      laminate: laminateThickness ? `${laminateThickness} mil` : 'None',
      finished: formatMil(finishedThickness),
    };
  }

  function setField(container, field, value) {
    const target = container.querySelector(`[data-srd-spec-field="${field}"]`);
    if (target) target.textContent = value || '';
  }

  function getVariantById(variants, id) {
    if (!id) return null;
    return variants.find((variant) => String(variant.id) === String(id)) || null;
  }

  function getCurrentVariant(container, variants) {
    const productInfo = container.closest('product-info') || document;
    const idInput = productInfo.querySelector('form[action*="/cart/add"] input[name="id"]');
    return getVariantById(variants, idInput?.value);
  }

  function getProductInfoVariants(productInfo) {
    return parseJson(productInfo, '[data-srd-product-variants]', []);
  }

  function getProductInfoCurrentVariant(productInfo, fallbackVariant) {
    if (fallbackVariant) return fallbackVariant;

    const variants = getProductInfoVariants(productInfo);
    if (!variants.length) return null;

    return getCurrentVariant(productInfo, variants) || variants[0];
  }

  function getProductQuantity(productInfo) {
    const quantityInput =
      productInfo.querySelector('form[action*="/cart/add"] input[name="quantity"]') ||
      productInfo.querySelector('quantity-input input[name="quantity"]') ||
      productInfo.querySelector('input[name="quantity"]');
    const quantity = Number(quantityInput?.value || 1);

    return Math.max(1, Math.floor(Number.isFinite(quantity) ? quantity : 1));
  }

  function setSmartShippingText(container, selector, value) {
    const target = container.querySelector(selector);
    if (target) target.textContent = value;
  }

  function setOfferUnlocked(container, selector, isUnlocked) {
    const target = container.querySelector(selector);
    if (target) target.classList.toggle('srd-offer--unlocked', isUnlocked);
  }

  function updateSpecs(container, variant) {
    if (!variant) return;

    const optionNames = parseJson(container, '[data-srd-product-options]', []);
    const sizeIndex = findOptionIndex(optionNames, ['size']);
    const materialIndex = findOptionIndex(optionNames, ['material']);
    const laminationIndex = findOptionIndex(optionNames, ['lamination', 'finish']);
    const size = variant.options?.[sizeIndex] || '';
    const material = variant.options?.[materialIndex] || '';
    const lamination = variant.options?.[laminationIndex] || '';
    const thickness = calculateThickness(material, lamination);

    setField(container, 'size', size);
    setField(container, 'material', material);
    setField(container, 'lamination', lamination);
    setField(container, 'material_thickness', thickness.material);
    setField(container, 'laminate_thickness', thickness.laminate);
    setField(container, 'finished_thickness', thickness.finished);
  }

  function updateContainerFromCurrentVariant(container, fallbackVariant) {
    const variants = parseJson(container, '[data-srd-product-variants]', []);
    if (!variants.length) return;

    const variant = fallbackVariant || getCurrentVariant(container, variants) || variants[0];
    updateSpecs(container, variant);
  }

  function updateAllSpecs(variant) {
    document
      .querySelectorAll('[data-srd-dynamic-specs][data-srd-product-family="safety_label"]')
      .forEach((container) => updateContainerFromCurrentVariant(container, variant));
  }

  function initAllSpecs() {
    updateAllSpecs();
  }

  function updateSmartShippingCard(card, fallbackVariant) {
    const productInfo = card.closest('product-info') || document;
    const variant = getProductInfoCurrentVariant(productInfo, fallbackVariant);
    if (!variant) return;

    const quantity = getProductQuantity(productInfo);
    const priceCents = Number(variant.price || 0);
    const totalCents = priceCents * quantity;
    const totalDollars = totalCents / 100;
    const freeShippingRemaining = Math.max(0, 35 - totalDollars);
    const bulkRemaining = Math.max(0, 50 - quantity);

    setSmartShippingText(card, '[data-srd-savings-qty]', String(quantity));
    setSmartShippingText(card, '[data-srd-savings-total]', formatMoney(totalCents));

    setSmartShippingText(
      card,
      '[data-srd-free-shipping-message]',
      freeShippingRemaining > 0
        ? `Spend ${formatMoneyAmount(freeShippingRemaining)} more to qualify.`
        : '✓ FREE USPS SHIPPING UNLOCKED'
    );
    setOfferUnlocked(card, '[data-srd-free-shipping-offer]', freeShippingRemaining === 0);

    setSmartShippingText(
      card,
      '[data-srd-bulk50-message]',
      bulkRemaining > 0
        ? `Add ${bulkRemaining} more decals to save 15%.`
        : '✓ BULK50 UNLOCKED\n15% discount applies automatically.'
    );
    setOfferUnlocked(card, '[data-srd-bulk50-offer]', bulkRemaining === 0);
  }

  function updateAllSmartShipping(fallbackVariant) {
    document
      .querySelectorAll('[data-srd-smart-shipping]')
      .forEach((card) => updateSmartShippingCard(card, fallbackVariant));
  }

  function initSmartShipping() {
    updateAllSmartShipping();
  }

  function getBulkPricingState(quantity) {
    if (quantity >= 100) {
      return {
        reached: false,
        tier: 'commercial',
        status: 'Commercial quantity selected',
        message: 'Request a Commercial Quote →',
        commercial: true,
      };
    }

    if (quantity >= 50) {
      return {
        reached: true,
        tier: '15',
        status: '✓ 15% savings level reached',
        message: 'Need 100+ decals?',
        commercial: true,
      };
    }

    if (quantity >= 25) {
      return {
        reached: true,
        tier: '10',
        status: '✓ 10% savings level reached',
        message: `Add ${50 - quantity} more decals to save 15%.`,
      };
    }

    if (quantity >= 10) {
      return {
        reached: true,
        tier: '5',
        status: '✓ 5% savings level reached',
        message: `Add ${25 - quantity} more decals to save 10%.`,
      };
    }

    if (quantity >= 4) {
      return {
        reached: true,
        tier: '3',
        status: '✓ 3% savings level reached',
        message: `Add ${10 - quantity} more decals to save 5%.`,
      };
    }

    return {
      reached: false,
      tier: '',
      status: 'Next Savings Level',
      message: `Add ${4 - quantity} more decals to save 3%.`,
    };
  }

  function updateBulkPricingCard(card) {
    const productInfo = card.closest('product-info') || document;
    const quantity = getProductQuantity(productInfo);
    const state = getBulkPricingState(quantity);

    card.classList.toggle('srd-bulk-pricing--unlocked', state.reached);
    card.classList.toggle('srd-bulk-pricing--commercial', !!state.commercial);
    setSmartShippingText(card, '[data-srd-bulk-status]', state.status);
    setSmartShippingText(card, '[data-srd-bulk-message]', state.message);

    card.querySelectorAll('[data-srd-bulk-tier]').forEach((tier) => {
      tier.classList.toggle('is-current', tier.dataset.srdBulkTier === state.tier);
    });
  }

  function updateAllBulkPricing() {
    document.querySelectorAll('[data-srd-bulk-pricing]').forEach(updateBulkPricingCard);
  }

  function initBulkPricing() {
    updateAllBulkPricing();
  }

  function protectMediaImage(image) {
    image.setAttribute('draggable', 'false');
    image.addEventListener('contextmenu', (event) => event.preventDefault());
    image.addEventListener('dragstart', (event) => event.preventDefault());
  }

  function initProductImageProtection() {
    document
      .querySelectorAll('product-info .product__media-wrapper img, product-info media-gallery img')
      .forEach(protectMediaImage);
  }

  function getChicagoParts(date) {
    const parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Chicago',
      weekday: 'short',
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
      hour12: false,
    }).formatToParts(date);

    return parts.reduce((result, part) => {
      if (part.type !== 'literal') result[part.type] = part.value;
      return result;
    }, {});
  }

  function chicagoDateToUtc(year, month, day, hour, minute) {
    const desiredMinutes = (((year * 12 + (month - 1)) * 31 + day) * 24 + hour) * 60 + minute;
    const guess = new Date(Date.UTC(year, month - 1, day, hour, minute));
    const actual = getChicagoParts(guess);
    const actualMinutes =
      (((Number(actual.year) * 12 + (Number(actual.month) - 1)) * 31 + Number(actual.day)) * 24 +
        Number(actual.hour)) *
        60 +
      Number(actual.minute);

    return new Date(guess.getTime() + (desiredMinutes - actualMinutes) * 60000);
  }

  function getChicagoCalendarDatePlusDays(parts, days) {
    const noon = chicagoDateToUtc(Number(parts.year), Number(parts.month), Number(parts.day), 12, 0);
    return getChicagoParts(new Date(noon.getTime() + days * 86400000));
  }

  function getNextShipDateParts(parts) {
    const weekday = parts.weekday;
    const daysUntilNextShip = {
      Mon: 1,
      Tue: 1,
      Wed: 1,
      Thu: 1,
      Fri: 3,
      Sat: 2,
      Sun: 1,
    }[weekday];

    return getChicagoCalendarDatePlusDays(parts, daysUntilNextShip || 1);
  }

  function formatShipDate(parts) {
    const date = chicagoDateToUtc(Number(parts.year), Number(parts.month), Number(parts.day), 12, 0);
    return new Intl.DateTimeFormat('en-US', {
      timeZone: 'America/Chicago',
      month: 'long',
      day: 'numeric',
    }).format(date);
  }

  function getShippingCountdownMessage(now) {
    const parts = getChicagoParts(now);
    const weekday = parts.weekday;
    const hour = Number(parts.hour);
    const minute = Number(parts.minute);
    const isBusinessDay = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'].includes(weekday);
    const beforeCutoff = hour < 14;

    if (isBusinessDay && beforeCutoff) {
      const cutoff = chicagoDateToUtc(Number(parts.year), Number(parts.month), Number(parts.day), 14, 0);
      const remainingMinutes = Math.max(0, Math.ceil((cutoff.getTime() - now.getTime()) / 60000));
      const hours = Math.floor(remainingMinutes / 60);
      const minutes = remainingMinutes % 60;
      return `🚚 Ships [[TODAY]]\nOrder within ${hours} hr ${String(minutes).padStart(2, '0')} min.`;
    }

    const nextShipParts = getNextShipDateParts(parts);
    const label = weekday === 'Fri' || weekday === 'Sat' || weekday === 'Sun' ? 'Monday' : 'Tomorrow';
    const statusLabel = label === 'Tomorrow' ? `[[${label}]]` : label;
    return `🚚 Ships ${statusLabel}\n${formatShipDate(nextShipParts)}`;
  }

  function formatCountdownMessage(message) {
    const escaped = String(message)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');

    return escaped.replace(/\[\[(.*?)\]\]/g, '<span class="srd-status-accent-gold">$1</span>');
  }

  function updateShippingCountdown() {
    const message = getShippingCountdownMessage(new Date());
    document.querySelectorAll('[data-srd-shipping-countdown-text]').forEach((target) => {
      target.innerHTML = formatCountdownMessage(message);
    });
  }

  function initShippingCountdown() {
    updateShippingCountdown();
    window.setInterval(updateShippingCountdown, 60000);
  }

  if (typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange && typeof subscribe === 'function') {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      window.setTimeout(() => updateAllSpecs(data?.variant), 0);
      window.setTimeout(() => updateAllSmartShipping(data?.variant), 0);
      window.setTimeout(() => updateAllBulkPricing(), 0);
      window.setTimeout(initProductImageProtection, 0);
    });
  }

  document.addEventListener('change', (event) => {
    if (event.target.closest('variant-selects')) {
      window.setTimeout(() => updateAllSpecs(), 150);
      window.setTimeout(() => updateAllSmartShipping(), 150);
      window.setTimeout(() => updateAllBulkPricing(), 150);
      return;
    }

    if (event.target.matches('input[name="quantity"]')) {
      window.setTimeout(() => updateAllSmartShipping(), 0);
      window.setTimeout(() => updateAllBulkPricing(), 0);
    }
  });

  document.addEventListener('input', (event) => {
    if (!event.target.matches('input[name="quantity"]')) return;
    window.setTimeout(() => updateAllSmartShipping(), 0);
    window.setTimeout(() => updateAllBulkPricing(), 0);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initAllSpecs();
      initProductImageProtection();
      initShippingCountdown();
      initSmartShipping();
      initBulkPricing();
    });
  } else {
    initAllSpecs();
    initProductImageProtection();
    initShippingCountdown();
    initSmartShipping();
    initBulkPricing();
  }
})();
